'use client'

import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { logErrorToNewRelic } from '@/lib/newrelic/logErrorToNewRelic'
import { useEffect, useRef } from 'react'
import { onNewVersion } from './__impl/AppVersionManager.onNewVersion'

/**
 * Compares app version on server (via env variable) and client (via html data-app-version attribute).
 * If versions differ, triggers a page reload to fetch the latest version.
 */
export function AppVersionManager({ appVersion }: { appVersion: string | undefined }) {
  const previousAppVersionRef = useRef<string | undefined>(appVersion)

  const { t } = useTranslation(['AppVersionManager'])

  useEffect(() => {
    const previousAppVersion = previousAppVersionRef.current
    previousAppVersionRef.current = appVersion

    if (!appVersion || !previousAppVersion) {
      console.error('AppVersionManager: One of the versions is undefined, skipping version check.')

      return
    }

    if (appVersion !== previousAppVersion) {
      logErrorToNewRelic(new Error(`${previousAppVersion} → ${appVersion}`))
      onNewVersion(previousAppVersion, appVersion, t('AppVersionManager:alert'))
    }
  }, [appVersion, t])

  return null
}
